import {
  Box,
  Card,
  Step,
  StepLabel,
  Stepper,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "styles/loader.css";
import * as Styles from "pages/requests/stepsIndividual/standalone-step5/step5.styles";
import Content from "./step5.content";

interface IProps {
    showMessage: MessageBox;
}

const Step5 = (props: IProps) => {
  const { showMessage } = props;
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.between("xs", "md"));
  const [activeSteps, setActiveSteps] = React.useState(4);

  const steps = [
    t("steps.step1"),
    t("steps.step2"),
    t("steps.step3"),
    t("steps.step4"),
    t("steps.step5"),
  ];

  useEffect(() => { 
  });

  return (
    <Box
      maxWidth="lg"
      sx={{
        zIndex: "1",
        p: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        my: "50px",
      }}
    >
      <Stepper activeStep={activeSteps} sx={{width:"100%", maxWidth: { xs: "390px", sm: "500px", md: "100%" },mb: "50px"}}>
        {steps.map((label, index) => {
          if (label !== "") {
            return (
              <Step key={label}>
                <StepLabel>{isMobile ? "" : label}</StepLabel>
              </Step>
            );
          }
          return "";
        })}
      </Stepper>
      
      {isMobile ? (
        <Content showMessage={showMessage} title={t("requestIndividual.step5.title")} changeActiveSteps={setActiveSteps}/>
      ) : (
        <Card sx={Styles.cardCSS(theme)}>
          <Content showMessage={showMessage} title={t("requestIndividual.step5.title")} changeActiveSteps={setActiveSteps}/>
        </Card>
      )}
    </Box>
  );
};

export default Step5;
